import { render, staticRenderFns } from "./vtnManagePayees.vue?vue&type=template&id=96a88d22"
import script from "./vtnManagePayees.vue?vue&type=script&lang=js"
export * from "./vtnManagePayees.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/devopsfs01/workspace/dev-rca-mobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('96a88d22')) {
      api.createRecord('96a88d22', component.options)
    } else {
      api.reload('96a88d22', component.options)
    }
    module.hot.accept("./vtnManagePayees.vue?vue&type=template&id=96a88d22", function () {
      api.rerender('96a88d22', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/customer/vtnManagePayees.vue"
export default component.exports